import { SchemaOf, date, number, object, string } from 'yup';

import {
  END_DATE_BEFORE_START_DATE,
  MAX_4_DECIMAL_LENGTH_YUP_TEMPLATE,
  MAX_STRING_LENGTH_YUP_TEMPLATE,
  MUST_BE_NUMBER,
  REQUIRED_FIELD
} from '@/config/text.const';

export interface Fields {
  customerId: string | null | undefined;
  poStatus: string | null | undefined;
  poNumber: string;
  poStartDate: Date | null | undefined;
  poEndDate: Date | null | undefined;
  poTotalValue: number | null | undefined;
  poNote: string | null | undefined;
  poCurrency: string | null | undefined;
}

export type CustomerOption = { label: string; value: string };
export type StatusOption = { label: string; value: string };

export const validationSchema: SchemaOf<Fields> = object().shape({
  customerId: string().optional().nullable(),
  purchaseOrderId: string().optional().nullable(),
  poStatus: string().optional().nullable(),
  poNumber: string().required(REQUIRED_FIELD).max(20, MAX_STRING_LENGTH_YUP_TEMPLATE),
  poStartDate: date().optional().nullable(),
  poEndDate: date()
    .optional()
    .nullable()
    .when('poStartDate', (poStartDate, schema) =>
      poStartDate ? schema.min(poStartDate, END_DATE_BEFORE_START_DATE) : schema,
    ),

  poTotalValue: number()
    .optional()
    .nullable()
    .typeError(MUST_BE_NUMBER)
    .test('max-decimals', MAX_4_DECIMAL_LENGTH_YUP_TEMPLATE, function (value) {
      if (value === undefined || value === null) return true;
      const decimalPlaces = (value.toString().split('.')[1] || '').length;
      return decimalPlaces <= 4;
    })
    .test('positive', 'Value must be positive', function (value) {
      return !value || value > 0;
    }),
  poNote: string().optional().nullable().max(200, MAX_STRING_LENGTH_YUP_TEMPLATE),
  poCurrency: string()
});
